import { useMemo } from 'react';
import { useStore } from 'hooks';
import { findFiasTreeHouseById } from 'utils';
import { IObject } from 'types';

export type HouseBinding = {
  houses: readonly string[];
  house_groups: readonly string[];
};

/**
 * Превращает привязку домов и групп домов (id) в объекты из дерева ФИАС,
 * чтобы передать их в FiasAddressesList.
 */
export const useHouseBindingSelection = (houseBinding?: HouseBinding) => {
  const { fias } = useStore();
  const houseIds = houseBinding?.houses ?? [];
  const houseGroupIds = houseBinding?.house_groups ?? [];
  const houseIdsKey = houseIds.join(',');
  const houseGroupIdsKey = houseGroupIds.join(',');

  // Считается в рендере, а не в эффекте, чтобы при показе списка бейджи
  // не пропадали на первый кадр
  return useMemo(() => {
    const selectedGroups: IObject[] = fias.houseGroups.filter((item: any) =>
      houseGroupIds.includes(item.id)
    );
    const selectedHouses: IObject[] = [];

    houseIds.forEach((houseId) => {
      findFiasTreeHouseById(fias.tree, houseId, selectedHouses as any, true);
    });

    return { selectedGroups, selectedHouses };
    // houseIds и houseGroupIds — observable-массивы, меняются на месте, поэтому
    // зависим от их строковых ключей
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [houseIdsKey, houseGroupIdsKey, fias.houseGroups, fias.tree]);
};
